@if (waiting()) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading contracts...</p>
  </div>
} @else {
  @if (contractObjectArray().length > 0) {
    <div class="connections-list">
      @for (contract of contractObjectArray(); track contract.contractId) {
        <mat-card class="connection-card" (click)="navigateToContract(contract)">
          <mat-card-content class="card-content">
            <div class="card-icon">
              <mat-icon>description</mat-icon>
            </div>
            <div class="card-details">
              <div class="card-title">{{ contract.nameOfContract || contract.friendlyName || 'Unnamed Contract' }}</div>
              <div class="card-chips">
                @if (contract.status) {
                  <mat-chip-set>
                    <mat-chip [class]="'status-chip status-' + (contract.status | lowercase)">{{ contract.status }}</mat-chip>
                  </mat-chip-set>
                }
                @if (contract.contractType) {
                  <span class="contract-type">{{ contract.contractType }}</span>
                }
              </div>
              <div class="card-meta">
                @if (contract.directVendorFriendlyName) {
                  <span class="meta-item">
                    <mat-icon class="meta-icon">business</mat-icon>
                    {{ contract.directVendorFriendlyName }}
                  </span>
                }
                @if (contract.effectiveDate) {
                  <span class="meta-item">
                    <mat-icon class="meta-icon">event</mat-icon>
                    {{ formatDate(contract.effectiveDate) }} - {{ formatDate(contract.expirationDate) }}
                  </span>
                }
              </div>
            </div>
            <mat-icon class="nav-arrow">chevron_right</mat-icon>
          </mat-card-content>
        </mat-card>
      }
    </div>
  } @else {
    <mat-card class="empty-state">
      <mat-card-content>
        <mat-icon>description</mat-icon>
        <p>No contracts associated</p>
      </mat-card-content>
    </mat-card>
  }
}
